import { mapGetters } from 'vuex';
import { frontendURL } from 'dashboard/helper/URLHelper';
import localesI18n from 'shared/constants/locales';
export default {
  computed: {
    ...mapGetters({ accountId: 'getCurrentAccountId' }),
    portalSlug() {
      return this.$route.params.portalSlug;
    },
    locale() {
      return this.$route.params.locale;
    },
  },
  methods: {
    articleUrl(id) {
      return frontendURL(
        `accounts/${this.accountId}/portals/${this.portalSlug}/${this.locale}/articles/${id}`
      );
    },
    allLocales() {
      return localesI18n(this.$i18n.locale);
    },
    localeName(code) {
      return this.allLocales()[code];
    },
  },
};